export default function BirthdayList({ birthdays }) {
  const message =
    birthdays.length > 1
      ? `Hoy Cumplen ${birthdays.length} pacientes:`
      : "Hoy cumple el siguiente paciente:";

  return (
    <>
      <h6>{message}</h6>
      {birthdays.map((birthday, index) => (
        <a
          style={{ color: "#25bbfa" }}
          href={`/database/show_orders1.php?id=${birthday["user_id"]}`}
          key={index}
        >
          {birthday["first_name"]} {birthday["last_name"]} |{" "}
          {birthday["cell_phone"]} |{" "}
          <span>ESP: {birthday["sales_person"]}</span>
        </a>
      ))}
    </>
  );
}
